import { render } from "./ModalOrderSubmitConfirm.vue?vue&type=template&id=019a8742"
import script from "./ModalOrderSubmitConfirm.vue?vue&type=script&lang=js"
export * from "./ModalOrderSubmitConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__